export default __webpack_public_path__ + "static/Get a daily summary of each worker’s movements@2x-f162c52bb9665c19f3fa7adcccb39d17.png";